import React from 'react';
import { FormSelect as Control, Value, Wrapper } from './styles';
import InvalidFeedback from '../InvalidFeedback';
import Dropdown from 'components/molecules/dropdown';
import { DropdownItemProps } from 'components/atoms/item/DropdownItem';

export interface Option<T extends number | string> extends DropdownItemProps {
    value: T;
    title: string;
    data?: any;
}

export interface FormSelectProps<T extends number | string> {
    error?: string;
    value?: T;
    inline?: boolean;
    options?: DropdownItemProps[];
    onChange?: (value: T) => void;
    isLight?: boolean;
    small?: boolean;
}

const FormSelect = <T extends number | string>({ error, value, onChange, inline, options, isLight, small }: FormSelectProps<T>) => {
    const label = options?.find((option) => option.value === value);

    return (
        <>
            <Wrapper>
                <Control inline={inline} isLight={isLight} small={small}>
                    <Dropdown
                        isFull={!isLight}
                        items={() =>
                            options?.map((option) => ({
                                ...option,
                                onClick: () => {
                                    onChange?.(option.value as T);
                                }
                            })) || []
                        }
                    >
                        <Value>{label?.title}</Value>
                    </Dropdown>
                </Control>
            </Wrapper>
            {error && <InvalidFeedback>{error}</InvalidFeedback>}
        </>
    );
};

export default FormSelect;
